const pricingAnalyticsConstants = {
  buyNow: 'buy_now',
  startFreeTrial: 'start_free_trial',
};

export default pricingAnalyticsConstants;
